<template>
  <div class="teacherList">
    <ul class="publick">
      <li v-for="(item, index) in info" :key="index">
        <router-link :to="{ path: '/teacherDetails', query: { id: item.id }  }">
          <div class="img"><img :src="item.avatar" width="80" height="80" alt=""></div>
          <div class="name">{{item.name}}</div>
          <div class="det">{{item.signature}}</div>
          <div class="con">{{item.profile}}</div>
        </router-link>
      </li>
    </ul>
  </div>
</template>

<script>
  export default {
    data () {
      return {
        info: {}
      }
    },
    created () {
      this.$store.state.headindex = 99
      this.getdata()
    },
    methods: {
      getdata () {
        this.$http.post('/apipx/Lecturer/lists', {
          token: JSON.parse(localStorage.getItem('login')).token
        }).then(res => {
          if (res.code === 0) {
            this.info = res.data
          }
        })
      }
    }
  }
</script>

<style type="text/scss" lang="scss">
  .teacherList {
    margin: 100px auto;
    overflow: hidden;
    padding-bottom: 40px;

    ul {

      li {
        width: 288px;
        height: 358px;
        background-color: #fff;
        border-radius: 20px;
        float: left;
        margin: 80px 16px 0 0;
        box-shadow: 0px 0px 20px #f6f6f6;

        &:nth-child(4n) {
          margin-right: 0;
        }

        .img {
          margin: -40px auto 0;
          width: 80px;
          height: 80px;

          img {
            border-radius: 50%;
          }
        }

        .name {
          font-size: 16px;
          text-align: center;
          margin: 15px auto 0;
        }

        .det {
          text-align: center;
          margin: 10px auto 0;
          color: #6f6f6f;
          display: -webkit-box;
          -webkit-box-orient: vertical;
          -webkit-line-clamp: 3;
          max-height: 90px;
          overflow: hidden;
          padding: 0 15px;
          line-height: 30px;
        }

        .con {
          line-height: 30px;
          height: 180px;
          overflow: hidden;
          display: -webkit-box;
          -webkit-box-orient: vertical;
          -webkit-line-clamp: 5;
          padding: 0 15px;
          margin: 15px auto 0;
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/teacher/teacher.vue